import { fetcher } from '@commenda/utils';
import {
  AM_TP_DEMO_ROUTES,
  TAmDemoApproveVersionRequest,
  TAmDemoApproveVersionResponse,
  TAmDemoResult,
} from './types';

/**
 * Signs off the version the redline flags.
 *
 * Idempotent by state: approving an already-approved version returns it unchanged rather than erroring, so a
 * second click mid-demo shows the same screen.
 */
export async function approveAmTpDemoVersion(
  body: TAmDemoApproveVersionRequest
): Promise<TAmDemoResult<TAmDemoApproveVersionResponse>> {
  try {
    const response = await fetcher(AM_TP_DEMO_ROUTES.approveVersion, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      return { success: false, error: 'Failed to approve the changes' };
    }

    return {
      success: true,
      data: (await response.json()) as TAmDemoApproveVersionResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to approve the changes',
    };
  }
}
